import { useState, useEffect, useCallback } from 'react';
import { heroBanners } from '@/mocks/mangaData';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning]);

  const next = useCallback(() => {
    goTo((current + 1) % heroBanners.length);
  }, [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const banner = heroBanners[current];

  return (
    <section className="relative w-full h-[460px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 max-w-4xl mx-auto">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 text-accent-300 text-xs font-medium mb-6">
          <i className="ri-fire-line"></i>
          热门推荐
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
          {banner.title}
        </h2>
        <p className="text-background-200/90 text-sm md:text-base max-w-xl mb-8">
          {banner.subtitle}
        </p>
        <Link
          to={`/article/${banner.mangaId}`}
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-lg text-base font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-play-circle-line text-lg"></i>
          立即阅读
        </Link>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {heroBanners.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
              index === current
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
          />
        ))}
      </div>

      <button
        onClick={() => goTo((current - 1 + heroBanners.length) % heroBanners.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </section>
  );
}